export default __webpack_public_path__ + "static/media/data-international.9a77e203.png";